import React, { useState } from "react";
import "./App.css";

const ReblocLogo = ({ size = 60 }) => (
  <svg width={size * 1.8} height={size} viewBox="0 0 1800 700">
    <g transform="translate(120,100)">
      <path d="M0 0 H240 A120 120 0 0 1 240 240 H120 Z" fill="#2E4A3A"/>
      <path d="M0 0 L240 240 L0 500 Z" fill="#123524"/>
      <polygon points="0,260 160,120 160,420" fill="#E7E3D6"/>
      <polygon points="160,420 160,260 360,420" fill="#C49A6C"/>
    </g>
    <text x="700" y="300" fontFamily="Poppins, Arial, sans-serif"
      fontSize="170" fontWeight="700" fill="#1E3B2C">Rebloc</text>
    <text x="705" y="420" fontFamily="Montserrat, Arial, sans-serif"
      fontSize="52" letterSpacing="10" fill="#1E3B2C">COLLECT. SHRED. BUILD.</text>
    <text x="705" y="520" fontFamily="Montserrat, Arial, sans-serif"
      fontSize="44" letterSpacing="4" fill="#C49A6C">REFUSE NOTHING. REBUILD EVERYTHING.</text>
  </svg>
);

function Login() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");

  // Read source AND machineId from the URL. Each Pi's QR code now
  // encodes its own machine ID (see QR_URL in config/settings.py), so
  // a scan at Machine A carries a different URL than a scan at
  // Machine B -- this is what lets the backend start only the correct
  // machine's shredder, instead of every machine reacting to any login.
  const urlParams = new URLSearchParams(window.location.search);
  const source    = urlParams.get("source") || "web";
  const machineId = urlParams.get("machineId") || null;

  const handleLogin = async () => {
    if (!email) { alert("Please enter your email"); return; }
    if (source === "machine" && !machineId) {
      alert("This QR code is missing its machine ID. Please contact staff -- do not proceed, as this could accidentally start the wrong machine.");
      return;
    }
    setLoading(true);
    setStatusMsg("");
    try {
      const res = await fetch(
        "https://smart-bin-backend-zygj.onrender.com/api/auth/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email })
        }
      );
      const data = await res.json();

      localStorage.setItem("token",   data.token);
      localStorage.setItem("role",    data.user.role);
      localStorage.setItem("email",   data.user.email);
      localStorage.setItem("userId",  data.user.id);
      localStorage.setItem("credits", data.user.credits);

      const role = data.user.role;

      // Only create a Pi-facing session if:
      // 1. User role (not admin/operator)
      // 2. AND they came from scanning the QR at a machine (source=machine)
      // This means website logins never trigger any shredder, and the
      // machineId ensures it's ONLY the specific machine that was scanned.
      if (role === "user" && source === "machine") {
        setStatusMsg("Connecting to bin machine...");
        try {
          const sessionRes = await fetch(
            "https://smart-bin-backend-zygj.onrender.com/api/session/login",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ email: data.user.email, source: "machine", machineId })
            }
          );
          if (!sessionRes.ok) {
            const errText = await sessionRes.text();
            console.error("Machine session creation failed:", sessionRes.status, errText);
            setStatusMsg("Warning: could not connect to bin machine. Please try scanning again.");
          } else {
            console.log("Machine session created successfully for", data.user.email, "at", machineId);
            setStatusMsg("Connected! Redirecting...");
          }
        } catch (sessionErr) {
          console.error("Machine session request threw an error:", sessionErr);
          setStatusMsg("Warning: network error connecting to bin machine.");
        }
      }

      const redirect = () => {
        if (role === "admin" || role === "rhino") window.location.href = "/admin";
        else if (role === "operator")             window.location.href = "/operator";
        else                                      window.location.href = "/dashboard";
      };
      if (role === "user" && source === "machine") {
        setTimeout(redirect, 1800);
      } else {
        redirect();
      }

    } catch (err) {
      console.error(err);
      alert("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-logo-wrap">
          <ReblocLogo size={50} />
        </div>
        <h2 className="login-heading">Smart Bin ♻️</h2>
        <p className="login-sub">Place plastic on scale · Scan QR · Earn rewards</p>
        <div className="login-form">
          <input
            type="email"
            placeholder="Enter your email"
            className="login-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleLogin()}
          />
          <button className="login-button" onClick={handleLogin} disabled={loading}>
            {loading ? "..." : "Login"}
          </button>
          {statusMsg && <p className="login-status">{statusMsg}</p>}
        </div>
        <p className="login-footer">Part of Rebloc's decentralised plastic recovery system</p>
      </div>
    </div>
  );
}

export default Login;